export const SERVER_BASE = "https://events.brahmakumaris.org/bkregistration";
// export const SERVER_BASE = "http://localhost:8080"
